import guides from './guides.json';

const siteUrl = 'https://tressym.eu';
const defaultImage = `${siteUrl}/tressym-og-image.png`;

export const seoByPath = {
    '/': {
        title: 'Tressym Drone Labs | Open-source FPV racing drones',
        description: 'Open-source FPV racing drone frames, parts and OSD fonts from Tressym Drone Labs. Free to download and modify.',
        type: 'WebSite'
    },
    '/frames': {
        title: 'FPV Racing Drone Frames | Tressym Drone Labs',
        description: 'Browse open-source FPV drone frames from Tressym Drone Labs, including Serval, Bengal and Blackfoot.',
        type: 'CollectionPage'
    },
    '/frames/serval': {
        title: 'Serval 5-inch FPV Racing Drone Frame | Tressym Drone Labs',
        description: 'Serval is an open-source 5-inch FPV racing drone frame by Tressym Drone Labs. See detailed specifications, download TPU parts, get build tips.',
        type: 'Product',
        productName: 'Serval 5-inch FPV racing drone frame'
    },
    '/frames/bengal': {
        title: 'Bengal 2.5-inch FPV Toothpick Drone Frame | Tressym Drone Labs',
        description: 'Bengal is a 2.5-inch open-source toothpick FPV drone frame by Tressym Drone Labs. See detailed specifications, download TPU parts, get build tips.',
        type: 'Product',
        productName: 'Bengal 2.5-inch FPV toothpick drone frame'
    },
    '/frames/blackfoot': {
        title: 'Blackfoot Ultralight FPV Drone Frame | Tressym Drone Labs',
        description: 'Blackfoot is a tiny, 3D-printable open-source FPV drone frame for extreme agility, stealth and cuteness. Free to download, print and modify.',
        type: 'Product',
        productName: 'Blackfoot ultralight FPV drone frame'
    },
    '/parts': {
        title: 'FPV Drone Parts | Tressym Drone Labs',
        description: 'Browse open-source FPV drone parts from Tressym Drone Labs, including the Joker ultralight tinywhoop racing canopy.',
        type: 'CollectionPage'
    },
    '/parts/joker': {
        title: 'Joker Tinywhoop Racing Canopy | Tressym Drone Labs',
        description: 'Joker is an open-source ultralight tinywhoop racing canopy with great camera and flight-controller protection from Tressym Drone Labs. Free to download, print and modify.',
        type: 'Product',
        productName: 'Joker tinywhoop racing canopy'
    },
    '/fonts': {
        title: 'Open-source OSD Fonts for FPV | Tressym Drone Labs',
        description: 'Download open-source OSD fonts designed for analog and HDZero systems from Tressym Drone Labs.',
        type: 'CollectionPage'
    },
    '/guides': {
        title: 'FPV Guides | Tressym Drone Labs',
        description: 'Practical guides for building, tuning and getting the most from open-source FPV drone designs.',
        type: 'CollectionPage'
    },
    '/fonts/maverick': {
        title: 'Maverick OSD Font for FPV | Tressym Drone Labs',
        description: 'Maverick is an open-source OSD font for analog Betaflight flight controllers from Tressym Drone Labs.',
        type: 'DigitalDocument',
        productName: 'Maverick analog Betaflight OSD font'
    },
    '/fonts/mainframe': {
        title: 'Mainframe OSD Font for FPV | Tressym Drone Labs',
        description: 'Mainframe is an open-source OSD font for HDZero goggles from Tressym Drone Labs.',
        type: 'DigitalDocument',
        productName: 'Mainframe HDZero OSD font'
    }
};

const normalizePath = (pathname) => {
    if (pathname === '/') return pathname;
    return pathname.replace(/\/$/, '');
};

export const getSeoForPath = (pathname) => {
    const normalizedPath = normalizePath(pathname);
    const guideMatch = normalizedPath.match(/^\/guides\/([^/]+)$/);

    if (guideMatch) {
        const guide = guides.find(({ slug, public: isPublic }) => slug === guideMatch[1] && isPublic);
        if (guide) {
            return {
                title: `${guide.title} | Tressym Drone Labs`,
                description: guide.description,
                type: 'Article',
                image: guide.image || defaultImage
            };
        }
        return {
            title: 'Guide not found | Tressym Drone Labs',
            description: 'This guide could not be found.',
            type: 'WebPage',
            noIndex: true
        };
    }

    return seoByPath[normalizedPath] || seoByPath['/'];
};

export const getCanonicalUrl = (pathname) => {
    const normalizedPath = normalizePath(pathname);
    return `${siteUrl}${normalizedPath === '/' ? '' : normalizedPath}`;
};

export { defaultImage, siteUrl };